// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"1d26e006","384":"1d26e006","485":"1d26e006","520":"1d26e006","582":"1d26e006","616":"1d26e006","696":"1d26e006"}[chunkId] + ".chunk.css";
};